import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=2960c6f5&"
import script from "@/components/page-header/PageHeader.ts?vue&type=script&lang=ts&"
export * from "@/components/page-header/PageHeader.ts?vue&type=script&lang=ts&"
import style0 from "@/components/page-header/page-header.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports